import { flow, getRoot, getSnapshot, Instance, SnapshotIn, types } from 'mobx-state-tree';

import { IRootStore } from '../RootStore';
import spotifyService from './../../services/spotifyService';
import TrackModel from './TrackModel';

const AlbumModel = types
    .model('AlbumModel', {
        id: types.identifier,
        name: types.string,
        artist: types.string,
        image: types.string,
        tracks: types.optional(types.map(types.reference(TrackModel)), {}),
    })
    .actions(self => {
        const getTracks = flow(function*() {
            const rootStore: IRootStore = getRoot(self);
            try {
                if (self.tracks.size) {
                    return;
                }
                const response: SpotifyApi.AlbumTracksResponse = yield spotifyService.getAlbumTracks(self.id);
                response.items.forEach(track => {
                    self.tracks.set(track.id, rootStore.music.addTrackFromSimplified(track, getSnapshot(self)));
                });
            } catch (error) {
                console.log(error);
                if (error.status === 401) {
                    rootStore.auth.signOut();
                }
            }
        });
        return { getTracks };
    });

export interface IAlbumModel extends Instance<typeof AlbumModel> {}
export interface IAlbumModelSnapshotIn extends SnapshotIn<typeof AlbumModel> {}

export default AlbumModel;
